import { v4 as uuidv4 } from 'uuid'

import speakersData2025 from 'resources/speakers/2025'
import { TAgenda, TSpeaker } from 'types'

const JeffBarr = speakersData2025.find(item => item.name === 'Jeffrey Barr') as TSpeaker
const TejasGupta = speakersData2025.find(item => item.name === 'Tejas Gupta') as TSpeaker
const MananVerma = speakersData2025.find(item => item.name === 'Manan Verma') as TSpeaker
const VaheMomjyan = speakersData2025.find(item => item.name === 'Vahe Momjyan') as TSpeaker
const AntonBabenko = speakersData2025.find(item => item.name === 'Anton Babenko') as TSpeaker
const MarcinCzelej = speakersData2025.find(item => item.name === 'Marcin Czelej') as TSpeaker
const InnaOzhogina = speakersData2025.find(item => item.name === 'Inna Ozhogina') as TSpeaker
const EdmondBokhyan = speakersData2025.find(item => item.name === 'Edmond Bokhyan') as TSpeaker
const ArsenMuradyan = speakersData2025.find(item => item.name === 'Arsen Muradyan') as TSpeaker
const AramKarapetyan = speakersData2025.find(item => item.name === 'Aram Karapetyan') as TSpeaker
const GagikKhalafyan = speakersData2025.find(item => item.name === 'Gagik Khalafyan') as TSpeaker
const MariuszMikcinski = speakersData2025.find(item => item.name === 'Mariusz Mikcinski') as TSpeaker
const GiorgiKeratishvili = speakersData2025.find(item => item.name === 'Giorgi Keratishvili') as TSpeaker

const agendaData2025: TAgenda[] = [
  {
    id: uuidv4(),
    date: '09:30',
    title: 'Check-in Open',
    language: null,
    hall: null,
    info: null,
    type: 'start',
    speakersList: null,
  },
  {
    id: uuidv4(),
    date: '10:00 10:25',
    title: 'Opening ceremony',
    language: 'En',
    hall: 'Manoogian Hall',
    info: null,
    type: 'start',
    speakersList: null,
  },

  {
    id: uuidv4(),
    date: '10:30 11:30',
    title: 'Operational Excellence at AWS scale',
    level: 'Leadership session',
    language: 'En',
    hall: 'Manoogian Hall',
    info: null,
    type: 'start',
    speakersList: [VaheMomjyan],
  },
  {
    id: uuidv4(),
    date: '11:35 12:35',
    title: 'Next Generation Software Development',
    level: 'Leadership session',
    language: 'En',
    hall: 'Manoogian Hall',
    info: null,
    type: 'start',
    speakersList: [JeffBarr],
  },
  {
    id: uuidv4(),
    date: '12:40 13:40',
    title: 'Doing serverless on AWS with Terraform for real',
    level: 'L300 (Advanced)',
    language: 'En',
    hall: 'Manoogian Hall',
    info: null,
    type: 'start',
    speakersList: [AntonBabenko],
  },
  {
    id: uuidv4(),
    date: '13:45 14:20',
    title: 'Lunch break & Networking',
    language: null,
    hall: null,
    info: null,
    type: 'start',
    speakersList: null,
  },

  // Track 1

  {
    id: uuidv4(),
    date: '14:30 15:20',
    title: 'Discovering AWS WAF Capabilities to Protect Your Applications',
    level: 'L300 (Advanced)',
    language: 'En',
    hall: 'Classroom 208E',
    info: null,
    type: 'trackOne',
    speakersList: [TejasGupta, MananVerma],
  },

  {
    id: uuidv4(),
    date: '15:35 16:30',
    title: (
      <>
        Code-Driven AWS Infrastructure: Fast, Secure, and Audit-Ready <span>(Compliant)</span>
      </>
    ),
    level: 'L200-L300 (Intermediate - Advanced)',
    language: 'En',
    hall: 'Classroom 208E',
    info: null,
    type: 'trackOne',
    speakersList: [AramKarapetyan],
  },

  {
    id: uuidv4(),
    date: '16:40 17:30',
    title: 'Empowering Developers with AWS Amplify: A Toolkit for Speed and Scale',
    level: 'L200 (Intermediate)',
    language: 'En',
    hall: 'Classroom 208E',
    info: null,
    type: 'trackOne',
    speakersList: [EdmondBokhyan],
  },

  // Track 2
  {
    id: uuidv4(),
    date: '14:30 15:20',
    title: (
      <>
        Amazon’s culture of innovation <span>(non-technical)</span>
      </>
    ),
    level: 'Leadership session',
    language: 'En',
    hall: 'Classroom 207E',
    info: null,
    type: 'trackTwo',
    speakersList: [InnaOzhogina],
  },

  {
    id: uuidv4(),
    date: '15:35 16:30',
    title: 'Enhancing A/B Testing and Observability on AWS  EKS with Cilium and eBPF',
    level: 'L200 (Intermediate)',
    language: 'En',
    hall: 'Classroom 207E',
    info: null,
    type: 'trackTwo',
    speakersList: [ArsenMuradyan],
  },

  {
    id: uuidv4(),
    date: '16:40 17:30',
    title: 'The Mythical Hero DevOps Engineer: Navigating the Career Maze',
    level: 'Self-Career Leadership',
    language: 'En',
    hall: 'Classroom 207E',
    info: null,
    type: 'trackTwo',
    speakersList: [GiorgiKeratishvili],
  },

  // Workshops

  {
    id: uuidv4(),
    date: '14:30 16:00',
    title: 'Building Agentic Workflows on AWS',
    level: 'L300 (Advanced)',
    language: 'En',
    hall: 'Classroom 416W',
    info: null,
    type: 'workshops',
    speakersList: [MariuszMikcinski, MarcinCzelej],
  },

  {
    id: uuidv4(),
    date: '16:05 17:30',
    title: 'Building Generative AI Apps on AWS with CDK',
    language: 'En',
    level: 'Level: L300 (Advanced)',
    hall: 'Classroom 416W',
    info: null,
    type: 'workshops',
    speakersList: [GagikKhalafyan],
  },

  // End

  {
    id: uuidv4(),
    date: '17:35 18:00',
    title: 'Closing ceremony, game, gifts and group photo',
    language: null,
    hall: 'Manoogian Hall',
    info: null,
    type: 'end',
    speakersList: null,
  },
]

export default agendaData2025
